module.exports = __webpack_public_path__ + "img/chevron-left-light.d143e0af.svg";